import { render, staticRenderFns } from "./InfoReveal.vue?vue&type=template&id=bb3f4bde&scoped=true&"
import script from "./InfoReveal.vue?vue&type=script&lang=js&"
export * from "./InfoReveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3f4bde",
  null
  
)

export default component.exports